import React from "react";
import { useNavigate } from "react-router-dom";
import pictureOne from "./assets/picOne.png";

const TestingServices = () => {
  const navigate = useNavigate();

  const labAreas = [
    "General Chemistry Laboratory",
    "Food Chemistry Laboratory",
    "Petrochemicals Laboratory",
    "Pesticides Residues and Formulation Laboratory",
    "Microbiology Laboratory",
    "Radiochemistry Laboratory",
    "Engineering and Materials Laboratories",
  ];

  const handleClick = (labName) => {
    navigate("/TestingLaboratories", { state: { scrollTo: labName } });
  };

  return (
    <div className="about-us">
      {/* Header */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Testing Services</h1>
          <p className="subtitle">
            Scientific testing and analysis ensuring product safety, quality, and compliance.
          </p>
        </div>
      </section>

      {/* Overview */}
      <section className="overview-section">
        <div className="overview-card">
          <h2>Laboratory Facilities</h2>
          <div className="labs-grid">
            {labAreas.map((area, index) => (
              <div
                key={index}
                className="lab-card"
                onClick={() => handleClick(area)}
              >
                <p>{area}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Inline CSS */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        /* Header */
        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
        .page-title { font-size: 3rem; font-weight: bold; margin-bottom: 10px; }
        .subtitle { font-size: 1.1rem; line-height: 1.8; }

        /* Overview Section */
        .overview-section { padding: 60px 20px; display: flex; justify-content: center; }
        .overview-card {
          max-width: 1500px;
          width: 100%;
          background: #f9f9f9;
          border-radius: 15px;
          padding: 40px 50px;
          box-shadow: 0 6px 25px rgba(0,0,0,0.1);
        }
        .overview-card h2 { color: #ff6600; margin-bottom: 20px; }

        /* Labs Grid */
        .labs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }
        .lab-card {
          background-color: #ffffff;
          border: 2px solid #ff6600;
          border-radius: 12px;
          padding: 25px;
          text-align: center;
          font-weight: bold;
          color: #333;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .lab-card:hover {
          background-color: #ff6600;
          color: white;
          transform: translateY(-5px);
        }

        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 2rem; }
          .overview-card { padding: 30px 25px; }
          .labs-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 15px; }
        }
      `}</style>
    </div>
  );
};

export default TestingServices;
